import BannerLancamentosService from '../services/banner.lancamentos.service';

export const bannerLancamentos = {
  namespaced: true,
  actions: {
    get({ commit }) {
      return BannerLancamentosService.get();
      // return BannerHomeService.get().then(
      //   resp => {
      //     return Promise.resolve(resp);
      //   },
      //   error => {
      //     return Promise.reject(error);
      //   }
      // );
    }
  },
  mutations: {
    }
};
